import $ from 'jquery'
import prop from 'vue-strict-prop'
import { component } from 'vue-tsx-support'

/**
 * An accordion allows users to toggle the display of sections of content.
 */
export default component({
	name: 'Accordion',
	props: {
		trigger: prop(String).default('.title'),
	},
	mounted(): void {
		const vm = this
		$(this.$el).accordion({
			selector: {
				trigger: this.trigger,
			},
			onClose() {
				vm.$emit('close', this)
			},
			onClosing() {
				vm.$emit('closing', this)
			},
			onOpen() {
				vm.$emit('open', this)
			},
			onOpening() {
				vm.$emit('opening', this)
			},
		})
	},
	methods: {
		open(index: number): void {
			$(this.$el).accordion('open', index)
		},
	},
	render() {
		return (
			<div class="ui accordion">
				{this.$slots.default}
			</div>
		)
	},
})
